<template>
  <v-app>
    <!-- Laptop view -->
    <v-main class="hidden-md-and-down">
      <v-row>
        <v-col cols="12" md="1" sm="1" lg="1">
          <NavMenu/>
        </v-col>
        <v-spacer />
        <v-col cols="12" md="10" sm="10" lg="10">
          <v-container style="padding:44px 127px 40px 136px">
            <div style="margin-bottom:24px">
              <span
                class="font-weight-bold"
                style="padding-top:3px;text-decoration:none;font-size:24px"
              >
                Activities</span
              >

              <v-menu transition="slide-x-transition" bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    height="34px"
                    width="99px"
                    
                    style="float:right;font-size:12px;padding:5px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon style="margin-right:10px"
                      >mdi-filter-variant</v-icon
                    >
                    Sort by</v-btn
                  >
                </template>

                <v-list>
                  <v-list-item @click="sortbyAmount">
                    <v-list-item-title>Sort by Amount</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

        
            <!-- <div style="margin-left:-10px;width:100%;margin-top:16.5px">
              <v-btn
                @click="allTransactions()"
                text
                depressed
                style="width:1%;font-size:14px"
                >All</v-btn
              >
              <v-btn
                text
                @click="successfulTransactions()"
                depressed
                style="width:15%;font-size:14px"
                >Successful</v-btn
              >
              <v-btn
                text
                @click="pendingTransactions()"
                depressed
                style="width:10%,font-size:14px"
                >Pending</v-btn
              >
              <v-btn
                text
                @click="declinedTransactions()"
                depressed
                style="width:20%,font-size:14px"
                >Declined</v-btn
              >
            </div> -->

            <div style="margin-left:0px">
             <div v-if="!loading">
              <v-list  v-for="(item, i) in limitedActivities" :key="i">
                <v-list-item class="transborders">
                  <v-list-item-avatar>
                    <v-img :src="item.image"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <span
                      class="font-weight-bold"
                      style="margin:5px 10px 0px 0px;text-align:start;font-size:13px"
                      >{{ item.title }}</span
                    >
                    <span style="font-size:11px;text-align:start">{{
                      item.status
                    }}</span>
                  </v-list-item-content>
                  <v-list-item-content>
                <span
                  style="font-size:14px;text-align:end"
                  >{{item.currency}} {{ parseFloat(item.amount).toFixed(2).toLocaleString("en") }}</span
                >
                    <span style="font-size:10px;text-align:end">{{
                      String(item.timestamp)
                    }}</span>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              
              </div>

              <v-skeleton-loader
                v-if="loading"
                type="list-item-avatar-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
                v-if="loading"
                type="list-item-avatar-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
                v-if="loading"
                type="list-item-avatar-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
                v-if="loading"
                type="list-item-avatar-two-line"
              ></v-skeleton-loader>
            </div>

            <div style="margin-top:25px">
                    
                    <div style="float:right">
                      <span
                        style="font-size:14px;font-weight:400"
                      >
                        Rows per page</span
                      >
                      <v-menu
                        transition="slide-x-transition"
                        bottom
                        right
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            color="#B0BAC9"
                            class="ml-2"
                            height="30px"
                            width="39px"
                            outlined
                          >
                            <span>{{ row }}</span>
                            <v-icon small
                              >mdi-chevron-down</v-icon
                            ></v-btn
                          >
                        </template>

                        <v-list>
                          <v-list-item @click="rowFive">5 </v-list-item>
                          <v-list-item @click="rowTen">10 </v-list-item>
                          <v-list-item @click="rowFifteen">15 </v-list-item>
                          <v-list-item @click="rowTwenty">20 </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
        
          </v-container>
        </v-col>
      </v-row>
    </v-main>

    <!-- Phone view -->
    <v-main class="hidden-lg-and-up pa-3 pt-5 mb-12">
      <v-container>
        <div style="margin-bottom:24px">
          <span
            class="font-weight-bold"
            style="padding-top:3px;text-decoration:none;font-size:24px"
          >
            Activities</span
          >
          <v-menu transition="slide-x-transition" bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                height="42"
                width="42"
                style="float:right"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon style="margin-right:10px">mdi-filter-variant</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="sortbyAmount">
                <v-list-item-title>Sort by Amount</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <!-- <div style="margin-left:-10px;width:100%;margin-top:16.5px">
          <v-btn
            @click="allTransactions()"
            text
            depressed
            style="width:10px;font-size:10px"
            >All</v-btn
          >
          <v-btn
            text
            @click="successfulTransactions()"
            depressed
            style="width:25%;font-size:10px"
            >Successful</v-btn
          >
          <v-btn
            text
            @click="pendingTransactions()"
            depressed
            style="font-size:10px"
            >Pending</v-btn
          >
          <v-btn
            text
            @click="declinedTransactions()"
            depressed
            style="font-size:10px"
            >Declined</v-btn
          >
        </div> -->

        <div style="margin-bottom:110px;margin-left:0px;max-width:740px">
        <div v-if="!loading">
          <v-list v-for="(item, i) in limitedActivities" :key="i">
            <v-list-item v-if="item.status != undefined" class="transborders">
              <v-list-item-avatar>
                <v-img :src="item.image"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <span
                  class="font-weight-bold"
                  style="margin:5px 10px 0px 0px;text-align:start;font-size:13px"
                  >{{ item.title }}</span
                >
                <span style="font-size:11px;text-align:start">{{
                  item.status
                }}</span>
              </v-list-item-content>
              <v-list-item-content>
                <span
                  style="font-size:13px;text-align:end"
                  >{{item.currency}} {{ parseFloat(item.amount).toFixed(2).toLocaleString("en") }}</span
                >
                <span style="color:#95A1A6;font-size:10px;text-align:end">{{
                  String(item.timestamp)
                }}</span>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          </div>
          <v-skeleton-loader
            v-if="loading"
            type="list-item-avatar-two-line"
          ></v-skeleton-loader>
          <v-skeleton-loader
            v-if="loading"
            type="list-item-avatar-two-line"
          ></v-skeleton-loader>
          <v-skeleton-loader
            v-if="loading"
            type="list-item-avatar-two-line"
          ></v-skeleton-loader>
          <v-skeleton-loader
            v-if="loading"
            type="list-item-avatar-two-line"
          ></v-skeleton-loader>

          <div style="margin-top:25px">
                    <div style="float:right">
                      <span
                        style="font-size:14px;font-weight:400"
                      >
                        Rows per page</span
                      >
                      <v-menu
                        transition="slide-x-transition"
                        bottom
                        right
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="ml-2"
                            height="30px"
                            width="39px"
                            outlined
                          >
                            <span >{{ row }}</span>
                            <v-icon small
                              >mdi-chevron-down</v-icon
                            ></v-btn
                          >
                        </template>

                        <v-list>
                          <v-list-item @click="rowFive">5 </v-list-item>
                          <v-list-item @click="rowTen">10 </v-list-item>
                          <v-list-item @click="rowFifteen">15 </v-list-item>
                          <v-list-item @click="rowTwenty">20 </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
        </div>
                        
     
      </v-container>
    </v-main>
    
    <v-dialog v-model="success" max-width="500">
      <v-card elevation="24" class="createAccount pa-7 text-center">
        <v-icon size="100px" color="white">mdi-check-circle</v-icon>
        <h1
          style="font-size:23px;padding:10px;color:white"
          class="font-weight-black"
        >
          {{title}}
        </h1>
        <p style="font-size:15px;color:white">{{ message }}</p>
        <v-btn @click="done()" elevation="24"> Ok</v-btn>
      </v-card>
    </v-dialog>

     <v-dialog v-model="error" max-width="500">
      <v-card elevation="24" class="createAccount pa-7 text-center">
        <v-icon size="100px" color="white">mdi-close-circle</v-icon>
        <h1
          style="font-size:23px;padding:10px;color:white"
          class="font-weight-black"
        >
          {{ title }}
        </h1>
        <p style="font-size:15px;color:white">
          {{ message }}
        </p>
        <v-btn @click="error = false" elevation="24"> Close</v-btn>
      </v-card>
    </v-dialog>
    <BottomMenu class="hidden-lg-and-up" />
  </v-app>
</template>

<script>
import BottomMenu from "@/components/BottomMenu";
import NavMenu from "@/components/NavMenu";
import { mapGetters,mapState } from 'vuex'
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
// import moment from 'moment'

export default {
  name: "Activities",
  components: {
    BottomMenu,
    NavMenu
  },

  data() {
    return {
      row:5,
      rowwithdraw:5,
      success:false,
      error:false,
      message:"",
      title:""

    };
  },

  computed: {
     ...mapState({
      loading: "loading",
      userData: "userData",
      walletBalance: "walletBalance",
      activities: "activities",
      bankDetails: "bankDetails",
      subscribers: "subscribers",
      notifications: "notifications",
      username: "username",
    }),
    ...mapGetters({
      user: "user",
    }),

     limitedActivities(){
        return this.activities.slice(-this.row)
    },

   

    //     giftNames() {
    //     function getFullName(item) {
    //      var fullname = [item.name].join(" ");
    //      return fullname;
    // }  return this.giftcards
    //     },
  },
  

   async beforeCreate() {
     if(localStorage.getItem('tippingsKey') == null){
     const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error) => {
          console.log(error);
        });
   }
   
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.person =  user
      if (!user) {
        this.$router.push("/login");
      }
    });
        if (this.activities == undefined) {
      await this.$store.dispatch("fetchUserData");
    }
  },

  methods: {
    rowFive() {
      this.row = 5
    },
    rowTen() {
      this.row = 10
    },
    rowFifteen() {
      this.row = 15
    },
    rowTwenty() {
      this.row = 20
    },
    sortbyAmount() {
      this.activities.sort((a, b) => a.amount - b.amount);
    },
  },
};
</script>

<style scoped>

.v-btn:active {
  border-bottom: solid 1px #1ca08a;
  color: #f5ce2c;
  box-shadow: 0px;
}

.v-btn:visited {
  border-bottom: solid 1px #1ca08a;
  color: #f5ce2c;
  box-shadow: 0px;
}

.v-btn:hover {
  color: #f5ce2c;
  border-bottom: solid 1px#1ca08a;
  box-shadow: 0px;
}





</style>
